import React from "react";
import { IconProps } from "../constants/GlobalTypesAndEnumsAndConstants";
import { colors } from "../constants/GlobalStyles";

const IconCarotArrowDown = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.width || "33"}
    height={props.height || "32"}
    viewBox="0 0 33 32"
    fill="none"
    style={{ marginLeft: "0px" }}
    {...props}
  >
    <path
      d="M10.1833 11.44L16.3033 17.56L22.4233 11.44L24.3033 13.3333L16.3033 21.3333L8.30334 13.3333L10.1833 11.44Z"
      fill={props.color || colors.secondaryAction.default}
    />
  </svg>
);

export default IconCarotArrowDown;
